<template>
    <div v-if="this.uri == '/notfound?catalog=true'" class="not-found-catalog page">
        <div class="uk-container uk-container-large">
            <div class="not-found-catalog-content">
                <div class="text-1">
                    <div class="item-1">Товар</div>
                    <div class="item-2">не найден</div>
                </div>
                <div class="text-2">Возможно, вас заинтересует продукция ниже</div>
                <ProductCarousel v-if="products.length > 0" :products="products"/>
                <div class="button">
                    <button @click="goToCatalog" class="button button-red">Перейти в каталог</button>
                </div>
            </div>
        </div>
    </div>
    <div v-else class="not-found page">
       <div class="section section_beige section_cover section_cover-medium">
            <div class="uk-container uk-container-large">
                <div class="section__title-wide">
                    <wide-title 
                        class="wide-title_red"
                        :title="notFound"
                    />
                    <wide-title 
                        class="wide-title_dark"
                        title="не найдена"
                    />
                </div>

                <div class="info-container">
                    <div class="info-header">
                        КОМПАНИЯ <p>SOFT99 CORPORATION</p>
                        <div class="info-detail">   
                            была основана в 1954 году
                        </div>
                    </div>
                    <div class="info-about">
                        Компания является лидером по производству и продаже автохимии и автокосметики в Японии. 
                        Продукция компании экспортируется более чем в 20 стран мира.
                    </div>

                    <div class="info-video">
                        <iframe src="https://www.youtube.com/embed/EW29UrYQBig" 
                            title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; 
                            clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen>
                        </iframe>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import WideTitle from '@/components/wide-title/WideTitle'
import ProductCarousel from '@/components/products-carousel/ProductCarousel'
import utils from '../utils'

export default {
    components: {
        WideTitle,
        ProductCarousel,
    },
    props: {
        isDevice: null,
    },
    metaInfo: {
        title: 'Страница не найдена',
        titleTemplate: `%s - ${process.env.VUE_APP_NAME}`,
    },
    data() {
        return {
            uri: null,
            products: [],
            maxAtPage: 3,
            currentPage: 1,
            currentItem: 1,
            notFound: 'Страница',
        }
    },
    methods: {
        getUri() {
            this.uri = this.$route.fullPath
        },
        getProducts: async function()  {
            const { fetchData } = utils();
            const api = "product?serializer=product_card&popular=true"
            
            let response = await fetchData('get', api)
            if (response?.data) {
                this.products = response.data.reverse()
            }
        },
        goToCatalog() {
            this.$router.push('/catalog')
        }
    },
    created() {
        this.getUri()
        if (this.$route.fullPath == '/notfound?catalog=true') {
            this.getProducts()
        }
        if (this.$route.fullPath == '/notfound?article=true') {
            this.notFound = 'Статья'
        }
    }
}
</script>